<template>
    <div :class="gridClass">
        <intersect @enter="handleEnter">
            <div class="gh-card gh-card--program" @click="courseOverview">
                <div class="gh-card__header">
                    <figure class="gh-card__image" ref="cardImage"></figure>
                </div>
                <div class="gh-card__body">
                    <p class="program__title">{{ program.title }}</p>
                    <table class="gh-table" v-if="!hideDetail">
                        <tr class="program__detail">
                            <td>
                                <span class="program__icon"><i class="fa fa-hourglass" aria-hidden="true"></i></span>
                                <span class="program__label">Duration</span>
                            </td>
                            <td>{{ program.duration }}</td>
                        </tr>
                        <tr class="program__detail">
                            <td>
                                <span class="program__icon"><i class="fa fa-stack-overflow" aria-hidden="true"></i></span>
                                <span class="program__label">Format</span>
                            </td>
                            <td>{{ program.format }}</td>
                        </tr>
                        <!-- <tr class="program__detail">
                            <td>
                                <span class="program__icon"><i class="fa fa-cogs" aria-hidden="true"></i></span>
                                <span class="program__label">Type</span>
                            </td>
                            <td>{{ program.level }}</td>
                        </tr> -->
                    </table>
                </div>
            </div>
        </intersect>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        props: {
            program: {
                required: true,
                type: Object
            },

            gridClass: {
                type: String,
                default: 'col-xs-6 col-md-3'
            },

            newWindow: {
                type: Boolean,
                default: false
            },

            hideDetail: {
                type: Boolean,
                default: false
            },

            isCredential: {
                type: Boolean,
                default: false
            }
        },

        data () {
            return {
                imageLoaded: false
            }
        },

        methods: {
            handleEnter () {
                !this.imageLoaded && this.renderImage()
            },

            courseOverview() {
                let route = this.program.isCollection
                    ? `/catalogue/collections/${this.program.slug}`
                    : `/catalogue/courses/${this.program.slug}`;

                if (this.isCredential) {
                    route = this.program.lzRoute.replace('members', 'enrol')
                }

                return this.newWindow ? window.open(route) : this.$router.push(route);
            },

            renderImage() {
                const cardImage = new Image();
                const vm = this;

                cardImage.src= this.webpSupported
                        ? this.program.links.webp
                        : this.program.links.image

                cardImage.onload = function() {
                    if(vm.$refs.cardImage) {
                        vm.$refs.cardImage.style.backgroundImage = `url(${this.src})`;
                    }
                }

                this.imageLoaded = true
            }
        },

        computed: {
            ...mapGetters({
                userDetail: 'auth/userDetail',
            }),

             mhaMember () {
              return this.userDetail('profile')
            },

            webpSupported () {
                return !!document.querySelector('.webp-supported')
            }
        },

        watch: {
            program: {
                immediate: true,
                handler: function() {
                    // this.renderImage()
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .gh-table td {
        padding: 0 5px;
    }

    .gh-card__body {
        margin-bottom: 1rem;
    }
</style>
